import { Injectable } from '@angular/core';
import { BigNumber } from 'bignumber.js';

export type NumberType = string | number;

@Injectable({
    providedIn: 'root'
})
export class NumberHelperService {
    constructor() { }

    formatMoney(value, opts: any = {}): string {
        return this.formatValue(value, opts);
    }

    formatNumber(value, opts: any = {}): string {
        return this.formatValue(value, opts);
    }

    unformat(value, opts: any = {}) {
        return this._unformat(value, opts);
    }

    /** è·åæå¤§å¼ */
    max(n1: any, n2 = null) {
        if (Array.isArray(n1)) {
            return BigNumber.max.apply(null, n1).toFixed();
        } else {
            if (n1 && n2) {
                return BigNumber.maximum(n1, n2).toFixed();
            } else {
                console.error(`è¯·æä¾æ¯è¾çå¼n1ãn2.`);
            }
        }
    }

    /** æå°å¼ */
    min(n1: any, n2 = null) {
        if (Array.isArray(n1)) {
            return BigNumber.min.apply(null, n1).toFixed();
        } else {
            if (n1 && n2) {
                return BigNumber.minimum(n1, n2).toFixed();
            } else {
                console.error(`è¯·æä¾æ¯è¾çå¼n1ãn2.`);
            }
        }
    }

    /** æ±å */
    sum(n1: NumberType[]) {
        return BigNumber.sum.apply(null, n1).toFixed();
    }

    /** å¹³åæ° */
    avg(n1: NumberType, len: number) {
        return new BigNumber(n1).div(len).toFixed();
    }

    /**  å æ³ */
    plus(n1: NumberType, n2: NumberType) {
        return new BigNumber(n1).plus(n2).toFixed();
    }

    /** ä¹æ³ */
    multiplied(n1: NumberType, n2: NumberType) {
        new BigNumber(n1).times(n2).toFixed();
    }

    /** åæ³ */
    minus(n1: NumberType, n2: NumberType) {
        return new BigNumber(n1).minus(n2).toFixed();
    }

    /** æ¯å¦ç¸ç­ */
    eq(n1: NumberType, n2: NumberType): boolean {
        return new BigNumber(n1).eq(n2);
    }

    lt(n1: NumberType, n2: NumberType): boolean {
        return new BigNumber(n1).lt(n2);
    }
    gt(n1: NumberType, n2: NumberType): boolean {
        return new BigNumber(n1).gt(n2);
    }

    toNumber(n1: string) {
        return new BigNumber(n1).toNumber();
    }

    toFixed(n1: string, precision: number = 0) {
        return new BigNumber(n1).toFixed(precision);
    }

    convertCurrency(money) {
        // æ±å­çæ°å­
        const cnNums = new Array('é¶', 'å£¹', 'è´°', 'å', 'è', 'ä¼', 'é', 'æ', 'æ', 'ç');
        // åºæ¬åä½
        const cnIntRadice = new Array('', 'æ¾', 'ä½°', 'ä»');
        // å¯¹åºæ´æ°é¨åæ©å±åä½
        const cnIntUnits = new Array('', 'ä¸', 'äº¿', 'å');
        // å¯¹åºå°æ°é¨ååä½
        const cnDecUnits = new Array('è§', 'å', 'æ¯«', 'å');
        // æ´æ°éé¢æ¶åé¢è·çå­ç¬¦
        const cnInteger = 'æ´';
        // æ´åå®ä»¥åçåä½
        const cnIntLast = 'å';
        // æå¤§å¤ççæ°å­
        const maxNum = 999999999999999.9999;
        // éé¢æ´æ°é¨å
        let integerNum;
        // éé¢å°æ°é¨å
        let decimalNum;
        // è¾åºçä¸­æéé¢å­ç¬¦ä¸²
        let chineseStr = '';
        // åç¦»éé¢åç¨çæ°ç»ï¼é¢å®ä¹
        let parts;
        if (money == '') { return ''; }
        money = parseFloat(money);
        if (money >= maxNum) {
            // è¶åºæå¤§å¤çæ°å­
            return '';
        }
        if (money === 0) {
            chineseStr = cnNums[0] + cnIntLast + cnInteger;
            return chineseStr;
        }
        // è½¬æ¢ä¸ºå­ç¬¦ä¸²
        money = money.toString();
        if (money.indexOf('.') === -1) {
            integerNum = money;
            decimalNum = '';
        } else {
            parts = money.split('.');
            integerNum = parts[0];
            decimalNum = parts[1].substr(0, 4);
        }
        // è·åæ´åé¨åè½¬æ¢
        if (parseInt(integerNum, 10) > 0) {
            let zeroCount = 0;
            const IntLen = integerNum.length;
            for (let i = 0; i < IntLen; i++) {
                const n = integerNum.substr(i, 1);
                const p = IntLen - i - 1;
                const q = p / 4;
                const m = p % 4;
                if (n == '0') {
                    zeroCount++;
                } else {
                    if (zeroCount > 0) {
                        chineseStr += cnNums[0];
                    }
                    // å½é¶
                    zeroCount = 0;
                    chineseStr += cnNums[parseInt(n, 10)] + cnIntRadice[m];
                }
                if (m == 0 && zeroCount < 4) {
                    chineseStr += cnIntUnits[q];
                }
            }
            chineseStr += cnIntLast;
        }
        // å°æ°é¨å
        if (decimalNum !== '') {
            const decLen = decimalNum.length;
            for (let i = 0; i < decLen; i++) {
                let n = decimalNum.substr(i, 1);
                if (n !== '0') {
                    chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                }
            }
        }
        if (chineseStr === '') {
            chineseStr += cnNums[0] + cnIntLast + cnInteger;
        } else if (decimalNum === '') {
            chineseStr += cnInteger;
        }
        return chineseStr;

    }

    private _unformat(val, opts) {
        val = (val === null || val === undefined || isNaN(val)) ? '' : String(val);
        if (opts) {
            // å»åç¼
            if (opts.prefix) {
                val = val.replace(new RegExp(opts.prefix, 'g'), '');
            }

            // å»åç¼
            if (opts.suffix) {
                val = val.replace(new RegExp(opts.suffix, 'g'), '');
            }

            // å»æååä½åéç¬¦
            val = val.replace(/\,/g, '');
        }
        return val;
    }

    private formatValue(value, opts: any) {
        const bignum = new BigNumber(value);
        const fmt = {
            prefix: opts.prefix || '',
            suffix: opts.suffix || '',
            decimalSeparator: opts.decimal || '.',
            groupSeparator: opts.thousand || '',
            groupSize: 3
        };

        if (bignum.isNaN()) {
            return '';
        }

        let precision = opts.precision || 0;
        precision = Number(precision);

        return bignum.toFormat(precision, fmt);
    }
}
